module.exports = __webpack_public_path__ + "static/img/huijiao12.77f98f10.png";